import { Outlet } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import BackTop from "@/components/ui/BackTop";
import { ScrollToTop } from "@/lib/site";

export default function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <ScrollToTop />
      <SiteHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
      <BackTop />
    </div>
  );
}